import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSession from "vue-session";
import VueMoment from "vue-moment";
import VeeValidate from "vee-validate";
import HighchartsVue from "highcharts-vue";
import JsonExcel from "vue-json-excel";
import Multiselect from "vue-multiselect";
import BootstrapVue from "bootstrap-vue";
import VueExcelXlsx from "vue-excel-xlsx";
import CryptoJS from "vue-cryptojs";
import JsonCSV from "vue-json-csv";
import SmartTable from "vuejs-smart-table";
import VueQuillEditor from "vue-quill-editor";

// require styles
import "./css/quill.snow.css";

const config = {
  classes: true,
  events: "blur", //Nag- This makes validations to fire on blur and on submit
  classNames: {
    invalid: "is-invalid"
  }
};
Vue.config.devtools = true;
Vue.component("downloadExcel", JsonExcel);
Vue.use(VueMoment);
Vue.use(HighchartsVue);
Vue.use(BootstrapVue);
Vue.use(VueExcelXlsx);
Vue.use(SmartTable);
Vue.use(CryptoJS);
Vue.use(VueQuillEditor);
Vue.component("Multiselect", Multiselect);

Vue.use(VeeValidate, config);
export const bus = new Vue();
Vue.use(VueSession);
Vue.config.productionTip = false;
Vue.component("downloadCsv", JsonCSV);
new Vue({
  router,
  store,

  render: h => h(App)
}).$mount("#app");
